export const DEVICE_ID_KEY = 'device_id'

